export const isDateOlderThan7Days = (dateStr: string) => {
    const [day, month, year] = dateStr.split("-").map(Number);
    const creationDate = new Date(year, month - 1, day);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    creationDate.setHours(0, 0, 0, 0);

    const diffInMs = today.getTime() - creationDate.getTime();
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    const daysLeft = 7 - diffInDays;
    return daysLeft > 0 ? daysLeft : 0;
};
export function getRelativeDateInfo(targetDateStr: string): string {
  const today = new Date();
  const targetDate = new Date(targetDateStr);

  const yearDiff = targetDate.getFullYear() - today.getFullYear();
  const monthDiff = targetDate.getMonth() - today.getMonth();

  const totalMonths = yearDiff * 12 + monthDiff;
  const absMonths = Math.abs(totalMonths);

  if (absMonths >= 12) {
    const years = Math.floor(absMonths / 12);
    return `${years} an${years > 1 ? 's' : ''}`;
  } else if (absMonths > 0) {
    return `${absMonths} mois`;
  } else {
    const diffDays = Math.abs(Math.floor((targetDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24)));
    return `${diffDays} jour${diffDays > 1 ? 's' : ''}`;
  }
}

